import { baseServiceConfigSchema } from "../common/base-service-provider.js";
export const formSchema = {
    type: 'object',
    required: ['title', 'id', 'namespace', 'dataset', 'authentication'],
    properties: {
        title: {
            title: 'Name',
            type: 'string',
            default: 'Olyslager'
        },
        id: {
            title: 'Slug',
            type: 'string',
            pattern: '[0-9a-z_-]+',
            default: 'olyslager'
        },
        namespace: {
            title: 'Namespace',
            type: 'string',
            pattern: '^[A-Z][A-Za-z]+$',
            default: 'Olyslager'
        },
        dataset: {
            title: 'Dataset',
            type: 'string'
        },
        authentication: {
            title: 'Authentication',
            description: 'The following properties are encrypted and are obscured on this form to ensure the security of your data.',
            type: 'object',
            properties: {
                token: {
                    title: 'API Key',
                    type: 'string',
                    '@sensitive': true
                }
            },
            required: ['token']
        }
    }
};
export const formConfig = {
    order: ['title', 'id', 'namespace', 'dataset', 'authentication'],
    properties: {
        title: {
            widget: 'singleLineText',
            instructions: 'A human-readable name for this service.'
        },
        id: {
            widget: 'singleLineText',
            instructions: 'A unique identifier for this service. Only lowercase letters, numbers, hyphen, and underscore are allowed.'
        },
        namespace: {
            widget: 'singleLineText',
            instructions: 'A namespace to use for any generated types or queries. For example, if you enter `Foo` your types will be named `Foo_Bar`.'
        },
        dataset: {
            widget: 'singleLineText',
            instructions: 'A dataset identifier.'
        },
        authentication: {
            properties: {
                token: {
                    widget: 'sensitiveField',
                    instructions: 'API key provided by Olyslager'
                }
            },
            order: ['token']
        }
    }
};
export const serviceConfigSchema = {
    ...baseServiceConfigSchema,
    properties: {
        ...baseServiceConfigSchema.properties,
        serviceType: {
            enum: ['openapi']
        },
        authenticationType: {
            enum: ['bearer']
        },
        namespace: {
            type: 'string'
        },
        authentication: {
            type: 'object',
            properties: {
                type: {
                    enum: ['bearer']
                },
                prefix: {
                    type: 'string'
                },
                token: {
                    type: 'string'
                }
            },
            required: ['type', 'prefix', 'token']
        },
        options: {
            type: 'object',
            properties: {
                endpoint: {
                    type: 'string'
                },
                spec: {
                    type: 'string'
                },
                transformVersion: {
                    type: 'string'
                }
            },
            required: ['endpoint', 'spec', 'transformVersion'],
            additionalProperties: true
        }
    },
    required: [...baseServiceConfigSchema.required, 'namespace', 'authentication', 'options']
};
